"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var facepaint_1 = __importDefault(require("facepaint"));
var gridTheme = {
    gridColumns: 12,
    breakpoints: {
        // defaults below
        xxl: 1440,
        xl: 1200,
        lg: 1024,
        md: 768,
        sm: 576,
        xs: 575
    },
    row: {
        padding: 15
    },
    col: {
        padding: 15
    },
    container: {
        padding: 15,
        maxWidth: {
            // defaults below
            xxl: 1240,
            xl: 1240,
            lg: 1024,
            md: 720,
            sm: 540,
            xs: 540
        }
    }
};
exports.mq = facepaint_1["default"]([
    "@media(min-width: " + gridTheme.breakpoints.sm + "px)",
    "@media(min-width: " + gridTheme.breakpoints.md + "px)",
    "@media(min-width: " + gridTheme.breakpoints.lg + "px)",
    "@media(min-width: " + gridTheme.breakpoints.xl + "px)",
    "@media(min-width: " + gridTheme.breakpoints.xxl + "px)",
]);
exports["default"] = gridTheme;
//# sourceMappingURL=gridTheme.js.map